import { render, staticRenderFns } from "./TableCalculos.vue?vue&type=template&id=b11a3690&"
import script from "./TableCalculos.vue?vue&type=script&lang=js&"
export * from "./TableCalculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports